import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ReservationRepository from '../../../repositories/ReservationRepository';
import ReservationDataRepository from '../../../../data/repositories/ReservationDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute({ id }: any): any {
  try {
    yield put({ type: Types.CANCEL_RESERVATION_REQUEST });

    const repository: ReservationRepository = new ReservationDataRepository();
    XCheckpointManager.registerStart('Reserva recursos anulación');
    const response = yield call(repository.cancelReservation, id);
    XCheckpointManager.registerEnd('Reserva recursos anulación');
    if (!response) {
      yield put({
        type: Types.CANCEL_RESERVATION_FAILURE,
        error: 'No se pudieron procesar los datos.'
      });
      return;
    }
    yield put({
      type: Types.CANCEL_RESERVATION_SUCCESS,
      data: response
    });
    yield put({
      type: 'GET_SUBSCRIBEDSS'
    });
  } catch (error) {
    yield put({
      type: Types.CANCEL_RESERVATION_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos.'
    });
  }
}
